import { FormPage } from "./FormPage";
import { MobileBottomNavigation } from "./MobileBottomNavigation";
import { Header } from "./Header";
import { Horizontalbar } from "./Horizontalbar";
import { Sidebar } from "./Sidebar";
import sessionDB from "../../utils/sessionDB";

/**
 * Shared authenticated shell used by every HRMS/ESS page.
 * hrms-shell* classes provide layout fallback (see layout-fallback.css),
 * matching the AddEmployeePage pattern of scoped CSS + design tokens.
 *
 * The shell is pinned to the viewport height (`h-screen`) with `overflow-
 * hidden`, and only the sidebar's nav list and the main panel scroll
 * internally (`min-h-0` + `overflow-y-auto`). Previously the shell only had
 * a `min-height`, so once page content grew taller than the viewport the
 * whole document scrolled instead of just the panel — this is what kept
 * "fixing" the Welcome page's scroll behaviour.
 *
 * Breadcrumbs are intentionally not rendered. Callers may still pass
 * `breadcrumb` / `hideBreadcrumb` for API compatibility.
 */
export function AppLayout({
  children,
  overlay = null,
  className = "",
  formLayout = null,
  breadcrumb: _breadcrumb,
  hideBreadcrumb: _hideBreadcrumb = false,
}) {
  const uiOption = String(
    sessionDB.getUiOption() || "horizontalbar",
  ).trim().toLowerCase();
  const isHorizontalNavigation = uiOption === "horizontalbar";

  return (
    <div className="hrms-shell h-screen overflow-hidden flex flex-col font-sans text-foreground bg-workspace">
      <Header
        showMenuToggle={!isHorizontalNavigation}
        showBottomBorder={!isHorizontalNavigation}
      />
      <div className="hrms-shell__content flex flex-1 min-w-0 min-h-0">
        {uiOption === "sidebar" && <Sidebar />}
        <div className="hrms-shell__body flex flex-1 min-w-0 min-h-0 flex-col">
          {isHorizontalNavigation && <Horizontalbar />}
          <main
            className={`hrms-shell__main flex-1 min-h-0 px-4 sm:px-6 lg:px-8 py-6 lg:py-7 overflow-y-auto ${formLayout ? "hrms-shell__main--form" : className}`.trim()}
          >
            {formLayout ? (
              <FormPage size={formLayout} className={className}>{children}</FormPage>
            ) : children}
          </main>
        </div>
      </div>
      <MobileBottomNavigation />
      {overlay}
    </div>
  );
}
